import { FormControl, FormGroup } from '@angular/forms';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import {
  DialogTypeEnum,
  IDialogConfirm
} from '../../../models/dialog';
import { ILot, LotStatus, Mode } from '../../../models/generic';
import { TransferFragment, TransferTabs } from '../../../models/tabs';
import { ApiDialogService } from '../../../services/api/api-cdialog.service';
import { ApiLotDetailService } from '../../../services/api/api-lot-detail.service';

@Component({
  selector: 'app-card-lotes-repasse',
  templateUrl: './card-lotes-repasse.component.html',
  styleUrls: ['../card-lotes/card-lotes.component.scss']
})
export class CardLotesRepasseComponent implements OnChanges {
  @Input() lote!: ILot;
  @Input() tabType: number | string = 1;

  Mode = Mode;
  TransferTabs = TransferTabs;
  TransferFragment = TransferFragment;
  LotStatus = LotStatus;

  lotStatus: string = '';
  lotsForm!: FormGroup;

  constructor(
    private _dialogService: ApiDialogService,
    private _lotDetailService: ApiLotDetailService
  ) {}

  getLotStatusLabel(): string {
    const status = (this.lote.IntegrationError && 'Erro') || this.lote.BatchStatus || this.lote.StatusOfOnlending;
    return (status || '-').toString();
  }

  getLotStatusClass(): string {
    const normalizedStatus = this.getLotStatusLabel()
      .toLowerCase()
      .trim()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '');

    if (!normalizedStatus || normalizedStatus === '-' || normalizedStatus === 'sem lote') {
      return 'repasse-pill-neutral';
    }

    if (['faturado', 'refaturado', 'pago', 'integrado', 'concluido', 'aprovado', 'liberado', 'liberado parcialmente'].includes(normalizedStatus)) {
      return 'repasse-pill-success';
    }

    if (['revertido', 'reverso', 'reversed', 'estornado', 'cancelado', 'erro'].includes(normalizedStatus)) {
      return 'repasse-pill-danger';
    }

    if (['em andamento', 'andamento', 'processando', 'aguardando', 'aguardando aprovacao'].includes(normalizedStatus)) {
      return 'repasse-pill-info';
    }

    return 'repasse-pill-warn';
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildForm();
    this.lotStatus = this.lote.StatusOfOnlending?.toLowerCase().trim() ?? '';

    if (this.lotsForm) {
      this.lotsForm.patchValue(this.lote);
    }
  }

  buildForm(): void {
    this.lotsForm = new FormGroup({
      LotId: new FormControl(null),
      LotStatusPayment: new FormControl(null),
      LotPartner: new FormControl(null),
      LotDate: new FormControl(null),
      LotBank: new FormControl(null),
      LotValueTransfer: new FormControl(null),
      QtdeContracts: new FormControl(null),
      SaleChannel: new FormControl(null),
      StatusTransfer: new FormControl(null),
      Checked: new FormControl(false)
    });
  }

  // Repasse so tem lotes Type='Manual' em producao hoje (confirmado no banco,
  // 2026-08-28) — a rota legada 'detalhes-lote/:id' (Type='Automatic') nunca e
  // alcancada na pratica. Simplificado para sempre ir direto pra v2.
  routeToDetails(lotId: string): void {
    if (this.lote.IntegrationError)
      this.openErrorConfirmationDialog(lotId);
    else this._lotDetailService.routeToDetailEvent.next({ lotId, type: 'Manual' });
  }

  openErrorConfirmationDialog(lotId: string): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Erro de integração',
        title: `${this.lote.IntegrationMsg || '-'}`,
        confirm: 'Editar',
        dismiss: 'Voltar'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this._lotDetailService.routeToDetailEvent.next({ lotId, type: 'Manual' });
      }
    });
  }
}